import React from "react";
import "../AdminBatchListPage/style.scss";
import AdminSkuList from "../../../components/Admin/AdminSkuList";

const AdminSkuListPage = () => {
  return (
    <div className="admin_skus_page_wrapper">
      <AdminSkuList />
    </div>
  );
};

export default AdminSkuListPage;
